import React, { useEffect, useState } from 'react'
import HeaderPage from '../components/homePage/HeaderPage'
import FooterPage from '../components/homePage/FooterPage'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {  useDispatch, useSelector } from 'react-redux';
import { useRef } from "react";
import { registerUserLogin, verifyOtp } from '../store/authActions';
import HeaderUser from '../components/homePage/HeaderUser';


function SendOtp() {
const dispatch = useDispatch();
const navigate = useNavigate();
const { userId } = useParams();
const { userDetailLogin } = useSelector((state) => state.auth);
const [isLoading, setIsLoading] = useState(false)
const [isResending, setIsResending] = useState(false)
const [otpTimer, setOtpTimer] = useState(120)





  const [error, setError] = useState("");
  //const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState({
                                1: "",
                                2: "",
                                3: "",
                                4: ""
                              });
  

useEffect(() => {

if(user){
  //console.log('okkkkkkkkkkkkkkkllll', user)
  //navigate('/registration')

}

}, [user, navigate])

useEffect(() => {
  if (otpTimer <= 0) return;

  const intervalId = setInterval(() => {
    setOtpTimer((prev) => (prev > 0 ? prev - 1 : 0));
  }, 1000);

  return () => clearInterval(intervalId);
}, [otpTimer]);

const formatOtpTimer = (totalSeconds) => {
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
};

const handleResendOtp = async () => {
  if (otpTimer > 0 || !user) return;

  const mobileEmail = user.email || user.mobile;
  if (!mobileEmail) {
    setError("Unable to resend OTP. Please go back and try again.");
    return;
  }

  setIsResending(true);
  setError("");

  try {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/send-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile_email: mobileEmail }),
      credentials: "include"
    });

    const data = await res.json();

    if (data.status) {
      setOtp({ 1: "", 2: "", 3: "", 4: "" });
      inputsRef.current[1]?.focus();
      setOtpTimer(120);

      const nextUser = user.email
        ? { user_id: data.user_id || user.user_id, email: user.email }
        : { user_id: data.user_id || user.user_id, mobile: user.mobile };

      dispatch(registerUserLogin(nextUser));
    } else {
      setError(data.message || "Failed to resend OTP. Please try again.");
    }
  } catch (err) {
    setError("Failed to resend OTP. Please try again.");
  } finally {
    setIsResending(false);
  }
};

 

  

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");


        if (value.length > 1) return;

        setOtp(prev => ({
                ...prev,
                [index]: value
              }));

        if (value && index < 4) {
            inputsRef.current[index + 1].focus();
          }

    setError("")
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullOtp = otp[1] + otp[2] + otp[3] + otp[4];
    
    if(!fullOtp){
      setError("OTP is required")
      return 
    }
    
    
    setIsLoading(true)
    //console.log(user)
    
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp:fullOtp, userId:user.user_id}),
        
      });

      const data = await res.json();
      setIsLoading(false)

     

      if(data.status){
      dispatch(verifyOtp(data));
      dispatch(registerUserLogin(data));  
      // navigate('/basic-details')
     
     
      if(data.page){
              //console.log('okkkkkkkkkkkkkkkk', data, user)
             //navigate(`/${data.page}`)
             if(data.page === 'dashboard'){
               
               document.location.href=`/${data.page}` 
             } else {
             document.location.href=`/${data.page}?new=${userId}`
             }
            
            } else {
      
     
      
      document.location.href=`/basic-details`
      
            }
    
    
    } else {
        setError(data.message)
      }
      

      //console.log(data)
    
  };

  

 function maskEmail(email) {
  const [userEmail, domain] = email.split("@");  // split before and after @
  const visible = userEmail.slice(0, 3);         // first 3 chars
  return visible + "*****@" + domain;
}

const handleKeyDownOTP = (e, index) => {
        if (e.key === "Backspace") {

          if (otp[index]) {
              setOtp(prev => ({
                ...prev,
                [index]: ""
              }));
            }
           else if (index > 1) {
                inputsRef.current[index - 1].focus();

                setOtp(prev => ({
                  ...prev,
                  [index - 1]: ""
                }));
              }
            }
          };


  return (
    <>
      { userDetailLogin?._id ? <HeaderUser /> : <HeaderPage /> }
        
        <>
  <section className="inrbnr">
    <div className="container-fluid con-flu-padd">
      <div className="inrbnrContent">
        <h1>OTP </h1>
        <ul className="inrbrnNav">
          <li>
            <Link to={userDetailLogin?._id ? '/dashboard':'/'}>
              <img src="assets/img/icons/home.png" alt="home icon" />
            </Link>
            <img src="assets/img/icons/arrows.png" alt="arrows icons" />
          </li>
          
          <li>
            <Link to="#">OTP</Link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  {/* Section End */}
  <section>
    <div className="register-sec ">
      <div className="container-fluid con-flu-padd  ">
        <div className="container-fluid  bg-register ">
          <div className="row pb-70">
            <div className="col-12 p-0">
              <div className="headings">
                <h2>Find Your Soulmate</h2>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-box">
                <img src="assets/img/register/subh-vivah.png" alt="" />
              </div>
            </div>
            <div className="col-md-5">
              <div className="con-reg">
                <h3>Enter the one time password</h3>
                <div className="col-11">
                  <div className="line-bg" />
                </div>
                 
                <div className=" form-otp ">
                  <form onSubmit={handleSubmit}>
                  <p style={{ fontWeight: 500, letterSpacing: 1 }}>
                    { 
                    user?.email ? 'A code has been sent to '+maskEmail(user.email) :
                    user?.mobile ? 'A code has been sent to ******'+String(user?.mobile).slice(-4) : "" 
                    }
                    
                    
                  </p>
                  
                    <input type="text"
                    inputMode="numeric"
                    key={1}
                    maxLength={1} 
                    min={0}
                    ref={(el) => (inputsRef.current[1] = el)}
                    onChange={(e) => handleChange(e, 1)}
                    onKeyDown={(e) => handleKeyDownOTP(e, 1)}
                    style={{width:'48px'}}
                    value={otp[1]}
                    />
                    <input type="text" 
                    inputMode="numeric"
                    key={2}
                    maxLength={1} 
                    min={0}
                    ref={(el) => (inputsRef.current[2] = el)}
                    onChange={(e) => handleChange(e, 2)}
                    onKeyDown={(e) => handleKeyDownOTP(e, 2)}
                    style={{width:'48px'}}
                    value={otp[2]}
                    />
                    <input type="text"
                    inputMode="numeric"
                    key={3}
                    maxLength={1}
                    min={0} 
                    ref={(el) => (inputsRef.current[3] = el)}
                    onChange={(e) => handleChange(e, 3)}
                    onKeyDown={(e) => handleKeyDownOTP(e, 3)}
                    style={{width:'48px'}}
                    value={otp[3]}
                    />
                    <input type="text"
                    inputMode="numeric"
                    key={4}
                    maxLength={1}
                    min={0} 
                    ref={(el) => (inputsRef.current[4] = el)}
                    onChange={(e) => handleChange(e, 4)}
                    onKeyDown={(e) => handleKeyDownOTP(e, 4)}
                    style={{width:'48px'}}
                    value={otp[4]}
                    />
                    {error && <p className='error'>{error}</p>}
                  <br />
                  <div style={{ marginBottom: "12px" }}>
                    {otpTimer > 0 ? (
                      <p style={{ marginBottom: 0, fontSize: "14px" }}>
                        Resend OTP in {formatOtpTimer(otpTimer)}
                      </p>
                    ) : (
                      <button
                        type="button"
                        onClick={handleResendOtp}
                        disabled={isResending}
                        style={{
                          border: "none",
                          background: "transparent",
                          padding: 0,
                          color: "#fd0d95",
                          textDecoration: "underline",
                          cursor: isResending ? "not-allowed" : "pointer"
                        }}
                      >
                        {isResending ? "Resending..." : "Resend OTP"}
                      </button>
                    )}
                  </div>
                  <button className="back">
                    <Link style={{ color: "white" }} to="/registration">
                      Back
                    </Link>{" "}
                  </button>
                  <button className="verify-otp" type='submit' disabled={isLoading}>
                          {isLoading ? "Wait..." : "Verify OTP"}
                    
                      
                    
                  </button>
                  
                  </form>
                  
                </div>
                
              </div>
            </div>
            <div className="col-md-4">
              <div className="ic-con">
                <h3 className="">Why Register?</h3>
                <p>Exclusive Options From our Lovers</p>
                <div className="col-12">
                  <div className="line-bg" />
                </div>
                <div className="ic-img-con d-flex">
                  <div className="img-ic">
                    <img src="assets/img/register/file-search_.png" alt="" />
                  </div>
                  <div className="ic-cons">
                    <span>Lots of Genuine Profilesfor Marriage</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>



      <FooterPage />
    </>
  )
}

export default SendOtp
